import { MatchingOverview } from '@app/core/api/matching-analytics';

export interface MatchingAnalyticsState {
  overview: MatchingOverview | null;
  loading: boolean;
  error: string | null;
}

export const initialMatchingAnalyticsState: MatchingAnalyticsState = {
  overview: null,
  loading: false,
  error: null
};
